import React, { useCallback, useEffect, useState } from 'react';
import { View, ViewStyle } from 'react-native';

import { PositionIndicator } from './position-indicator/position-indicator.component';
import styles from './progress-bar.style';
import useOnLayout from '../../hooks/use-on-layout';
import { ProgressBarFragment } from '../progress-bar-fragment/progress-bar-fragment';
interface ProgressBarProps {
  completions: boolean[];
  currentIndex?: number;
  currentProgress: number;
  isIndicatorVisible: boolean;
  containerStyle?: ViewStyle;
}

export function ProgressBar({
  completions = [],
  currentIndex = 0,
  currentProgress = 0,
  isIndicatorVisible = true,
  containerStyle,
}: ProgressBarProps) {
  const [hasAnimationDelay, setAnimationDelay] = useState(true);
  const [{ width }, onLayout] = useOnLayout();
  const FRAGMENT_SEPARATOR_WIDTH = 10;

  useEffect(() => {
    setAnimationDelay(true);
  }, []);

  useEffect(() => {
    if (currentProgress > 0) {
      setAnimationDelay(false);
    }
  }, [currentProgress]);

  const markAnimationComplete = useCallback(
    (fragmentIndex) => {
      const isLastFragment = fragmentIndex === completions.length - 1;
      if (!isLastFragment) {
        return;
      }

      setAnimationDelay(false);
    },
    [completions.length]
  );

  const progressBars = completions.map((completed, index) => {
    let progress = 0;

    if (completed) {
      progress = 100;
    } else if (currentIndex === index) {
      progress = isNaN(currentProgress) ? 0 : currentProgress;
    }

    return (
      <ProgressBarFragment
        containerStyle={[
          styles.fragment,
          { marginHorizontal: FRAGMENT_SEPARATOR_WIDTH / 2 },
        ]}
        key={index}
        index={index}
        progress={progress}
        hasIndexAnimationDelay={hasAnimationDelay}
        markAnimationComplete={() => markAnimationComplete(index)}
      />
    );
  });

  return (
    <View onLayout={onLayout} style={[styles.container, containerStyle]}>
      {!!completions.length && (
        <>
          {progressBars}
          {isIndicatorVisible && (
            <PositionIndicator
              fragmentIndex={currentIndex}
              fragmentPosition={currentProgress / 100}
              separatorWidth={FRAGMENT_SEPARATOR_WIDTH}
              fragmentWidth={
                width / completions.length - FRAGMENT_SEPARATOR_WIDTH
              }
            />
          )}
        </>
      )}
    </View>
  );
}
